import React from 'react';
import { useIntl } from 'react-intl';

import { Amount, Input } from 'ui-lib';
import messages from '../../messages';
import useBetslipStakeInput from './useBetslipStakeInput';

import './betslipStakeInput.scss';

interface Props {
    value: string;
    changeValue: (stake: string) => void;
    isDisabled?: boolean;
    maxStake: string;
    onKeyDown?: InputEl['onKeyDown'];
}

const BetslipStakeInput: React.FC<Props> = ({
    maxStake,
    changeValue,
    value,
    isDisabled,
    onKeyDown,
}) => {
    const {
        setStake,
        stakes,
        onBlur,
        onFocus,
        isInputFocused,
    } = useBetslipStakeInput({
        maxStake,
        changeValue,
        value,
    });

    const { formatMessage } = useIntl();

    return (
        <div styleName="container">
            <Input
                value={value}
                onBlur={onBlur}
                onFocus={onFocus}
                onChange={setStake}
                isInputFocused={isInputFocused}
                isDisabled={isDisabled}
                onKeyDown={onKeyDown}
            />
            <div styleName="list">
                {stakes.map((stake, idx) => {
                    const isSelected = value === `${stake}`;

                    return (
                        <Amount
                            // NOTE: Don't use 'stake' as key of Amount. stakes are duplicated.
                            // eslint-disable-next-line react/no-array-index-key
                            key={idx}
                            isDisabled={isDisabled}
                            isActive={isSelected}
                            onClick={() =>
                                isSelected
                                    ? changeValue('')
                                    : changeValue(`${stake}`)
                            }
                        >
                            {stake === +maxStake
                                ? formatMessage(messages.maxButton)
                                : stake}
                        </Amount>
                    );
                })}
            </div>
        </div>
    );
};

export default BetslipStakeInput;
